module.exports = __webpack_public_path__ + "img/IMG_0095.2f34869d.jpg";